import { http } from "../../../services/apiCommunicated/Http.interceptor";
import Technician from './interfaces/Technician';

const URL: string = '/colaboradores/location/tecs';

export const getTechnician = () => {
    return http.get<Technician[]>(`${URL}`);
}

export const getByTechnician = (id: string) => {
    return http.get<Technician[]>(`${URL}/${id}`);
}

export const postTechnician = (Technician: Technician) => {
    return http.post<Technician>(`${URL}`, Technician);
}

export const putTechnician = (Technician: Technician) => {
    return http.put<Technician>(`${URL}`, Technician);
}

export const deleteTechnician = (id: string) => {
    return http.delete<string>(`${URL}/${id}`)
}
